<div class="snackbar {{show}}">{{message}}</div>
<section class="categories">
    <div class="banner" style="background: url('../../assets/img/sub.png');">
        <div class="head">
            <div class="heading">
                <h1 *ngIf="id==1">Bridal</h1>
                <h1 *ngIf="id==2">Casual</h1>
                <h1 *ngIf="id==3">Suits</h1>
                <h1 *ngIf="id==4">Groom</h1>
            </div>
        </div>
    </div>

    <div class="body">
        <div class="filter-line"><p (click)="openFilter(1)">filter</p></div>
        <div class="loader" *ngIf="isLoading">
            <mat-spinner style="margin:0 auto;" *ngIf="isLoading"></mat-spinner>
        </div>
        <div class="dresses">
            <div class="dress" *ngFor="let cloth of clothes; index as i">
                <div class="item-block2">
                    <div class="d-image4">
                        <img src="{{cloth.pic_urls[0]}}">
                    </div>
                    <div class="buttons">
                        <button (click)="openDialog(cloth)">Add to Cart</button>
                        <button (click)="navigate(cloth._id)">View Details</button>
                    </div>
                    <div class="dress-detail">
                        <p class="nam">{{cloth.dress_name}}</p>
                        <p class="price"><del>{{cloth.basic_rent+500}} pkr</del><b> {{cloth.basic_rent}} pkr</b></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="{{empty}}">
            <p>No Results Found</p>
        </div>
    </div>

    <div class="pagination"></div>

</section>